import React, {useState, useRef, useEffect} from "react";
import "./Fading.css";


export default function MultipleImages(props) {
  const [isVisible, setVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => setVisible(entry.isIntersecting));
    });
    observer.observe(domRef.current);
  }, []);

    const width= window.innerWidth;

  useEffect(() => {
    const width= window.innerWidth;
  }, []);

  const WrapperConditional = ({ condition, wrapper, children }) => {
    return condition ? wrapper(children) : children;
}

  return (
    <div 
    style={{
      position: "relative",
      display: "flex",
      flexDirection: width>=1200 ? "row":"column",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "black",
      padding: width>=1200 ? "2vw 10vw 2vw 10vw": "10vw 10vw 2vw 10vw",
    }}>
    {props.multipleImages.map((image, i) => (
    <div
        key={i}
        >
        <div
          className={`fade-in-section ${isVisible ? 'is-visible' : ''}`}
          ref={domRef}
          style={{padding: "10px 10px 10px 10px"}}>
            <WrapperConditional
            condition={!!image.url}
            wrapper={children => <a target="_blank" rel="noreferrer" href={image.url}>{children}</a>}
            >
        <img
          src={image.src}
          width= "100%"
          alt="description of image">
        </img>
            </WrapperConditional>

        </div>
    </div>

      ))
    }
    {/* {props.multipleImages.split("\r\n\r\n").map((s, i) => (
    <div
        key={i}
        >
        <div
          className={`fade-in-section ${isVisible ? 'is-visible' : ''}`}
          ref={domRef}
          style={{padding: "10px 10px 10px 10px"}}>
        <img
          src={s}
          width= "100%"
          alt="description of image">
        </img>
        </div>
    </div>

      ))
    } */}
  </div>
)}
  